import { GET_DASHBOARD_EARNINGS, GET_DASHBOARD_METRICS } from '@watter/shared-components';
import { client } from '../service/apolloClient';
import { hideLoader, showLoader } from '../store/reducers/appSlice';
import { store } from '../store';
import { GET_STATIC_LISTINGS } from '../graphql/heater-details';

export const fetchDashboardEarnings = async (): Promise<any | null> => {
    try {
        store.dispatch(showLoader());
        const { data } = await client.query({
            query: GET_DASHBOARD_EARNINGS,
            fetchPolicy: 'network-only',
        });

        return data?.getDashboardEarnings || null;
    } catch (error) {
        store.dispatch(hideLoader());
        console.error('Error fetching dashboard earnings:', error);
        throw error;
    } finally {
        store.dispatch(hideLoader());
    }
};

export const fetchDashboardMetrics = async (metrics: boolean = false): Promise<any | null> => {
    try {
        store.dispatch(showLoader());
        const { data } = await client.query({
            query: GET_DASHBOARD_METRICS,
            fetchPolicy: 'network-only',
            variables: {
                metrics,
            },
        });

        return data?.getDashboardMetrics || null;
    } catch (error) {
        store.dispatch(hideLoader());
        console.error('Error fetching dashboard metrics:', error);
        throw error;
    } finally {
        store.dispatch(hideLoader());
    }
};
export const fetchStaticData = async (): Promise<any | null> => {
    try {
        store.dispatch(showLoader());
        const { data } = await client.query({
            query: GET_STATIC_LISTINGS,
            fetchPolicy: 'network-only',
        });
        return data?.getStaticListings || null;
    } catch (error) {
        store.dispatch(hideLoader());
        console.error('Error fetching static data', error);
        throw error;
    } finally {
        store.dispatch(hideLoader());
    }
};
